import { ChangeDetectionStrategy, Component, OnInit, ViewChild, ElementRef, inject, signal } from '@angular/core';
import { APIService } from 'src/app/services/APIService/api.service';
import { first } from 'rxjs/operators';
import { UntypedFormGroup, UntypedFormControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { ToastService } from 'src/app/services/toast.service';
import { ClrDatagrid, ClarityModule } from '@clr/angular';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';
import { OverlayService } from 'src/app/services/Overlay/overlay.service';
import { ZählerMode } from '../zaehlerverwaltung/zaehler.enums';
import { CommonModule } from '@angular/common';

import { TablePrettyPrintPipe } from 'src/app/pipes/tablePrettyPrint.pipe';
import { HideIDColumnsPipe } from 'src/app/pipes/hide-idcolumns.pipe';
import { WebSocketService } from 'src/app/services/Websocket/websocket.service';
import { ConfirmService } from 'src/app/services/confirm.service';
import { Column, Row, Table } from 'src/app/models/ui/table';
import { BaseDataRoute, BaseItemsWrapperComponent } from '../../_modals/baseitems-wrapper/baseitems-wrapper.component';
import { getTokenRight } from 'src/app/misc/functions';

interface TreeDataNode {
  id: number;
  name: string;
  selected: boolean;
  expanded: boolean;
  parent: TreeDataNode | null;
  children: TreeDataNode[];
}

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-objekttypdialog',
  templateUrl: './objekttypdialog.component.html',
  styleUrls: ['./objekttypdialog.component.scss'],
  imports: [
    CommonModule,
    ClarityModule,
    FormsModule,
    ReactiveFormsModule,
    BaseItemsWrapperComponent,
    MrTranslatePipe,
    TablePrettyPrintPipe,
    HideIDColumnsPipe,
  ],
  providers: [WebSocketService],
})
export class ObekttypDialogComponent implements OnInit {
  private readonly apiservice = inject(APIService);
  private readonly toastr = inject(ToastService);
  private readonly authService = inject(AuthService);
  private readonly mrTranslate = inject(MrTranslatePipe);
  private readonly overlayService = inject(OverlayService);
  private readonly confirmService = inject(ConfirmService);

  private readonly webSocket = inject(WebSocketService);

  public closedialog: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public minSize;

  trial = false;

  constructor() {
    this.trial = this.authService.getToken().trial;
  }

  //@ViewChild('_name') _name: ElementRef;
  //@ViewChild('_bezeichnung') _bezeichnung: ElementRef;
  //@ViewChild('_typ') _typ: ElementRef;
  //@ViewChild('_icon') _icon: ElementRef;
  @ViewChild('_komptext') _komptext: ElementRef;

  @ViewChild('objekteDg', { static: false }) objekteDg: ClrDatagrid;
  @ViewChild('pruefungDg', { static: false }) pruefungDg: ClrDatagrid;
  @ViewChild('fileUploader') fileUploader: ElementRef;

  otypGroup = new UntypedFormGroup({
    name: new UntypedFormControl(''),
    bezeichnung: new UntypedFormControl(''),
    typ: new UntypedFormControl(''),
    icon: new UntypedFormControl(null),
  });

  protected readonly isBaseModalOpen = signal(false);
  protected readonly editTabelle = signal<BaseDataRoute>(null);

  openWerteliste(typ: number) {
    this.isBaseModalOpen.set(true);
    if (typ == 0) {
      this.editTabelle.set({
        tabelle: 'SMEH',
        title: this.mrTranslate.transform('Mengeneinheit'),
      });
    } else {
      this.editTabelle.set({
        tabelle: 'KEQUI',
        sub_id: this.otypid,
        title: this.mrTranslate.transform('SAP Equipment'),
      });
    }
  }

  openWertelisteBauwerk() {
    this.isBaseModalOpen.set(true);
    this.editTabelle.set({
      tabelle: 'SBAUW',
      title: this.mrTranslate.transform('Bauwerke'),
    });
  }

  treeclicktimer: any;

  root: TreeDataNode;

  iconColumns: string[] = ['typ', 'symbol'];
  seltyp: number = 1;
  otypid: number = 1;
  kprtypid: number = 1;
  allowMBEdit: boolean = false;
  rights;any;
  isinit: boolean = false;
  selobjekt: any = undefined;
  selpruefung: any = undefined;
  objekte: Table;
  pruefungen: Table;
  pruefungenOriginal: any;
  properties: any;
  sysobjektoptions: Table;
  sysobjektoptionsOriginal: any;
  UseKomponenten: boolean = false;
  komponenten: any;

  cursysobjektoptions: any;
  lastsysooptGroup: any;

  editObjektModal: boolean = false;
  modalObjekttitel: string = '';

  editKomponentenModal: boolean = false;
  modalKomponententtitel: string = '';

  selsymbol: any = undefined;
  selected: any;
  selsotypid: number;
  selTreeNote: any;
  selnodeid: number = 0;
  editnodeid: number = 0;

  importObjektModal: boolean = false;
  importObjektFile: any;
  progress: any = 0;
  spinner: any = {
    single: false,
    multi: false,
  };

  importjsonObj: any;
  importProgessValue: string = '';
  doUpload: boolean = false;
  info: string = '';
  optExportFormat: number = 0;
  optSAPFieldEquipment: boolean = false;
  Opt_F_Zaehler: number = 0;

  form = new UntypedFormGroup({
    clientId: new UntypedFormControl(),
  });

  items = ['Closeout', 'Construction', 'Engineering', 'Site Acquisition'];

  symbols: any = [
    { id: 1, name: 'Weiche' },
    { id: 2, name: 'Gleis' },
    { id: 3, name: 'Gleisabschluss' },
    { id: 4, name: 'Bahnübergang' },
    { id: 5, name: 'Mast' },
    { id: 6, name: 'Signal' },
    { id: 7, name: 'Oberleitung' },
    { id: 8, name: 'Brandschutz' },
    { id: 9, name: 'Brücke' },
    { id: 10, name: 'Tunnel' },
    { id: 11, name: 'Videoanlagen' },
    { id: 12, name: 'Weichensteuerung' },
    { id: 13, name: 'Haltestelle' },
    { id: 14, name: 'Unterwerk' },
    { id: 15, name: 'Stellwerk' },
    { id: 16, name: 'Weichenantrieb' },
    { id: 17, name: 'Weichenheizung' },
    { id: 18, name: 'Solaranlagen' },
    { id: 19, name: 'Beleuchtungsanlagen' },
    { id: 20, name: 'Fahrgastinformationssystem' },
    { id: 21, name: 'Fangschienen' },
    { id: 22, name: 'Bü-Sicherungsanlagen' },
    { id: 23, name: 'Gleissperre elektrisch' },
    { id: 24, name: 'Gleissperre mechanisch' },
    { id: 25, name: 'Schienenauszugsvorrichtung' },
    { id: 26, name: 'Radsensor' },
    { id: 27, name: 'Schaltschrank' },
    { id: 28, name: 'Kabel' },
    { id: 29, name: 'Lichtsignal' },
    { id: 30, name: 'Schienenkontakt' },
    { id: 31, name: 'Schienenkontakt isoliert' },
    { id: 32, name: 'Schienenprofil' },
    { id: 33, name: 'Stützmauer' },
    { id: 34, name: 'Durchlass' },
    { id: 35, name: 'Bahnsteig' },
    { id: 36, name: 'Damm' },
    { id: 37, name: 'Schmieranlage' },
    { id: 38, name: 'Flurstück' },
    { id: 39, name: 'Gebäude' },
    { id: 40, name: 'Anschlussbahn' },
    { id: 41, name: 'Anlage ortsfest' },
    { id: 42, name: 'Anlage mobil' },
    { id: 43, name: 'Geräte' },
    { id: 44, name: 'Dienstweg' },
    { id: 45, name: 'Stromschiene' },
    { id: 46, name: 'Drehscheibe' },
    { id: 47, name: 'Gleisbremse' },
    { id: 48, name: 'Kreuzung' },
    { id: 99, name: 'undefiniert' },
  ];

  sysooptGroup: UntypedFormGroup = new UntypedFormGroup({
    Opt_F_Einbauhistory: new UntypedFormControl(false),
    Opt_F_Zaehler: new UntypedFormControl(false),
    Opt_F_Linienbelegung: new UntypedFormControl(false),
    Opt_F_Logbuch: new UntypedFormControl(false),
    Opt_F_Bahnsteig: new UntypedFormControl(false),
    Opt_F_BUESicht: new UntypedFormControl(false),
    Opt_F_Trassierung: new UntypedFormControl(false),
    Opt_F_GMTZNumber: new UntypedFormControl(false),
    Opt_O_UseRailProfil: new UntypedFormControl(false),
    Opt_O_UseDIN1076: new UntypedFormControl(false),
    Opt_O_UseMessReg: new UntypedFormControl(false),
    Opt_F_Drawing: new UntypedFormControl(false),
    Opt_O_UseKomponenten: new UntypedFormControl(false),
    Opt_I_Zaehler: new UntypedFormControl(false),
    Opt_I_Del_Old_Image: new UntypedFormControl(false),
    Opt_I_Fehlerklasse: new UntypedFormControl(false),
    Opt_I_Zustaend_Abt: new UntypedFormControl(false),
    Opt_I_Gundinst: new UntypedFormControl(false),
    Opt_I_PassBild: new UntypedFormControl(false),
    Opt_I_Track_BauwZustand: new UntypedFormControl(false),
    Opt_I_Track_Spez_SchwellenNote: new UntypedFormControl(false),
    Opt_I_Track_Spez_Schwellenjahr: new UntypedFormControl(false),
    Opt_I_Track_Spez_Schienenhoehe: new UntypedFormControl(false),
    Opt_I_Track_Spez_Option_ZusatzI: new UntypedFormControl(false),
    Opt_I_Track_Spez_Option_ZusatzII: new UntypedFormControl(false),
    Opt_I_Track_Spez_Option_Unterbau: new UntypedFormControl(false),
    Opt_I_Track_Spez_Option_Einbaujahr: new UntypedFormControl(false),
    Opt_I_Track_Spez_Option_Daemmung: new UntypedFormControl(false),
    Opt_E_OrdZustand: new UntypedFormControl(false),
    Opt_E_OrdZustand_TXT_IO: new UntypedFormControl(''),
    Opt_E_OrdZustand_TXT_NIO: new UntypedFormControl(''),
    Opt_E_FK_ImageToDok: new UntypedFormControl(false),
    Opt_E_Sperr_ImageToDok: new UntypedFormControl(false),
    Opt_E_Spez_ListToDok: new UntypedFormControl(false),
    Opt_I_Anlagenklasse: new UntypedFormControl(false),
    Opt_I_Track_Spez_Schienenjahr: new UntypedFormControl(false),
    Opt_E_Track_Spez_Schienenhoehe: new UntypedFormControl(false),
    Opt_E_Fehlerklasse: new UntypedFormControl(false),
    Opt_E_Bezirk: new UntypedFormControl(false),
    Opt_E_Stellwerk: new UntypedFormControl(false),
    Opt_E_MessReg: new UntypedFormControl(false),
    Opt_E_Track_Spez_Schwellenjahr: new UntypedFormControl(0),
    Opt_F_Stellkraftmessung: new UntypedFormControl(false),
    Opt_F_Naturschutz: new UntypedFormControl(false),
    Opt_I_PruefIntIsMessInt: new UntypedFormControl(false),
    Opt_I_CheckList: new UntypedFormControl(false),
    Opt_K_Kalender: new UntypedFormControl(30),
    Opt_F_ZaehlerMessreg: new UntypedFormControl(false),
  });

  openZaehler() {
    this.overlayService.setOverlay({
      overlay: 'zaehlerverwaltung',
      isTopOverlay: true,
      mode: ZählerMode.ZÄHLER,
      otypid: this.otypid,
    });
  }

  openStellkraft() {
    this.overlayService.setOverlay({
      overlay: 'zaehlerverwaltung',
      isTopOverlay: true,
      mode: ZählerMode.STELLKRAFT,
      otypid: this.otypid,
    });
  }

  selectionObjektChanged(value: any) {
    if (!value) return;
    const filtered = this.pruefungenOriginal.filter(obj => {
      return obj.otypid === value.id;
    });

    this.otypid = value.id;
    this.seltyp = value.typ;
    if(this.rights) this.allowMBEdit = getTokenRight(this.rights.type[this.otypid], 'MGVEDIT');
    if (this.pruefungen) {
      this.pruefungen.rows = filtered;
      setTimeout(() => {
        if (this.pruefungDg) {
          this.pruefungDg.selected = [this.pruefungen.rows[0]];
          this.pruefungDg.selectedChanged.emit(this.pruefungen.rows);
        }
      }, 100);
    }

    this.selectionPruefungChanged(filtered[0]);

    //this.selpruefung(this.pruefungen.rows[0]);
  }

  addObjekt() {
    this.selsotypid = -1;
    this.selsymbol = this.symbols[0];
    this.editObjektModal = true;
    this.modalObjekttitel = this.mrTranslate.transform('Neues Objekt erstellen');
  }

  updateObjekt() {
    let vals = this.otypGroup.value;

    if (vals.name.toString().length == 0) {
      this.toastr.error(this.mrTranslate.transform('Geben Sie einen Namen ein'));
      return;
    }
    if (vals.bezeichnung.toString().length == 0) {
      this.toastr.error(this.mrTranslate.transform('Geben Sie eine Bezeichnung ein'));
      return;
    }

    if (this.selsotypid == -1) {
      if (this.objekte.rows.some(item => (item.name as string).toLowerCase() == vals.name.toString().toLowerCase())) {
        this.toastr.error(this.mrTranslate.transform('Namen wird bereits verwendet'));
        return;
      }

      if (
        this.objekte.rows.some(
          item => (item.bezeichnung as string).toLowerCase() == vals.bezeichnung.toString().toLowerCase()
        )
      ) {
        this.toastr.error(this.mrTranslate.transform('Bezeichnung wird bereits verwendet'));
        return;
      }
    }

    let n = vals.name.toString();
    let b = vals.bezeichnung.toString();
    let t = parseFloat(vals.typ.toString());
    let i = this.selsymbol.id;

    let sotyp = {
      Status: 'update',
      ID: this.selsotypid,
      Name: n,
      Bezeichnung: b,
      Typ: t,
      SysIcon: i,
    };

    this.apiservice
      .sendSOTYP({
        sotyp,
      })
      .pipe(first())
      .subscribe((res: any) => {
        if (res?.status) {
          this.seltyp = 1;
          this.loadSOTYP();
          this.loadObjektPruefungTypen();
          this.loadSysObjectOptions();
          this.editObjektModal = false;

          this.toastr.success(this.mrTranslate.transform('Daten gespeichert'));
        } else {
          this.toastr.warning(res.join('<br>'), this.mrTranslate.transform('Ein Fehler ist aufgetreten'));
        }
      });
  }

  treeClick(node: any): void {
    this.treeclicktimer = setTimeout(() => {
      this.selectTreeNode(node);
    }, 300);
  }

  treeDoubleClick(node: any): void {
    clearTimeout(this.treeclicktimer);
    this.treeclicktimer = undefined;

    if (node.parent == null) {
      return;
    } else {
      this.selnodeid = node.id;
    }
    this.selTreeNote = node;
    this.editKomponenten();
  }

  addKomponenten() {
    this._komptext.nativeElement.value = '';
    this.editnodeid = -1;
    this.modalKomponententtitel = 'Neue Komponente erstellen';
    this.editKomponentenModal = true;
  }

  editKomponenten() {
    this._komptext.nativeElement.value = this.selTreeNote.name;
    this.editnodeid = this.selnodeid;
    this.modalKomponententtitel = 'Komponente bearbeiten';
    this.editKomponentenModal = true;
  }

  async delKomponenten() {
    let text = 'Sind Sie sicher, dass Sie dieses Komponente löschen wollen?';
    if (this.selTreeNote.children.length > 0) {
      text =
        'Sind Sie sicher, dass Sie dieses Komponente mit alle Unterkomponente [' +
        this.selTreeNote.children.length.toString() +
        '] löschen wollen?';
    }
    const ok = await this.confirmService.danger(text);
    if (ok) {
      let ids = [this.selnodeid];

      for (const element of this.selTreeNote.children) {
        let c = element;
        ids.push(c.id);
      }

      let sotyp = {
        Status: 'deleteKomponent',
        ID: ids,
      };

      this.apiservice
        .sendSOTYP({
          sotyp,
        })
        .pipe(first())
        .subscribe((res: any) => {
          if (res?.status) {
            this.selnodeid = 0;
            this.loadKomponenten();

            this.toastr.success(this.mrTranslate.transform('Komponenten wurden gelöscht'));
          } else {
            this.toastr.warning(res.join('<br>'), this.mrTranslate.transform('Ein Fehler ist aufgetreten'));
          }
        });
    }
  }

  updateKomponenten() {
    if (this._komptext.nativeElement.value.toString().length == 0) {
      this.toastr.error(this.mrTranslate.transform('Error: Geben Sie eine Bezeichnung ein'));
      return;
    }

    let b = this._komptext.nativeElement.value.toString();
    let p = this.otypid;

    if (this.selTreeNote.parent !== null) p = this.selTreeNote.parent.id;

    let sotyp = {
      Status: 'updateKomponent',
      ID: this.editnodeid,
      Name: '-',
      Bezeichnung: b,
      Typ: this.selobjekt.typ,
      SysIcon: this.selobjekt.symbol,
      ParentOTypID: this.selobjekt.id,
      ParentID: p,
    };

    this.apiservice
      .sendSOTYP({
        sotyp,
      })
      .pipe(first())
      .subscribe((res: any) => {
        if (res?.status) {
          this.selnodeid = 0;
          this.loadKomponenten();
          this.editKomponentenModal = false;
          this.toastr.success(this.mrTranslate.transform('Daten gespeichert'));
        } else {
          this.toastr.warning(res.join('<br>'), this.mrTranslate.transform('Ein Fehler ist aufgetreten'));
        }
      });
  }

  selectTreeNode(node: any) {
    if (!this.treeclicktimer) return;
    if (node.parent == null) {
      this.selnodeid = 0;
    } else {
      this.selnodeid = node.id;
    }
    this.selTreeNote = node;
  }

  editShowObjekt(row: any) {
    this.otypGroup.controls.name.setValue(row.name);
    this.otypGroup.controls.bezeichnung.setValue(row.bezeichnung);
    this.otypGroup.controls.typ.setValue(row.typ);

    this.selsymbol = this.symbols.find(obj => {
      return obj.id === row.symbol;
    });
    this.selsotypid = row.id;
    this.modalObjekttitel = 'Objekt bearbeiten';
    this.editObjektModal = true;
  }

  async deleteObjek(id: number) {
    const ok = await this.confirmService.danger(
      this.mrTranslate.transform('Sind Sie sicher, dass Sie dieses Objekt löschen wollen?')
    );
    if (ok) {
      let sotyp = {
        Status: 'delete',
        ID: id,
      };

      this.apiservice
        .sendSOTYP({
          sotyp,
        })
        .pipe(first())
        .subscribe((res: any) => {
          if (res?.status) {
            this.seltyp = 1;
            this.loadSOTYP();
            this.loadObjektPruefungTypen();
            this.loadSysObjectOptions();

            this.toastr.success(this.mrTranslate.transform('Objekt wurden gelöscht'));
          } else {
            this.toastr.warning(res.join('<br>'), this.mrTranslate.transform('Ein Fehler ist aufgetreten'));
          }
        });
    }
  }

  changedKomponenten = evt => {
    if (evt.target.checked) {
      this.loadKomponenten();
    } else {
      this.UseKomponenten = evt.target.checked;
    }
  };

  loadKomponenten() {
    this.apiservice
      .getKomponenten(this.otypid)
      .pipe(first())
      .subscribe((val: any) => {
        this.komponenten = val;

        setTimeout(() => {
          for (const element of this.komponenten.rows) {
            let komp = element;
            if (komp.ParentID == 0) {
              this.root = {
                id: komp.ID,
                name: komp.Bezeichnung,
                selected: true,
                expanded: true,
                parent: null,
                children: [],
              };
              this.fillChildren(this.root, komp.ID);
            }
          }
          this.UseKomponenten = true;

          this.selTreeNote = this.root;
        }, 200);
      });
  }

  fillChildren(parentNode: TreeDataNode, iid: number) {
    const filtered = this.komponenten.rows.filter(obj => {
      return obj.ParentID === iid;
    });

    for (const element of filtered) {
      let komp = element;
      let node: TreeDataNode = {
        id: komp.ID,
        name: komp.Bezeichnung,
        selected: false,
        expanded: false,
        parent: parentNode,
        children: [],
      };
      parentNode.children.push(node);

      this.fillChildren(node, komp.ID);
    }
  }

  public getChildren = node => node.children;

  selectionPruefungChanged(value: any) {
    if (!value) return;
    this.cursysobjektoptions = this.sysobjektoptionsOriginal.find(obj => {
      return obj.OTYPID === value.otypid && obj.KPRTYPID == value.id;
    });

    this.kprtypid = value.id;

    this.sysooptGroup.controls.Opt_F_Einbauhistory.setValue(this.cursysobjektoptions.Opt_F_Einbauhistory);
    this.sysooptGroup.controls.Opt_F_Zaehler.setValue(this.cursysobjektoptions.Opt_F_Zaehler);
    this.sysooptGroup.controls.Opt_F_Linienbelegung.setValue(this.cursysobjektoptions.Opt_F_Linienbelegung);
    this.sysooptGroup.controls.Opt_F_Logbuch.setValue(this.cursysobjektoptions.Opt_F_Logbuch);
    this.sysooptGroup.controls.Opt_F_Bahnsteig.setValue(this.cursysobjektoptions.Opt_F_Bahnsteig);
    this.sysooptGroup.controls.Opt_F_BUESicht.setValue(this.cursysobjektoptions.Opt_F_BUESicht);
    this.sysooptGroup.controls.Opt_F_Trassierung.setValue(this.cursysobjektoptions.Opt_F_Trassierung);
    this.sysooptGroup.controls.Opt_F_GMTZNumber.setValue(this.cursysobjektoptions.Opt_F_GMTZNumber);
    this.sysooptGroup.controls.Opt_F_Stellkraftmessung.setValue(this.cursysobjektoptions.Opt_F_Stellkraftmessung);
    this.sysooptGroup.controls.Opt_F_Naturschutz.setValue(this.cursysobjektoptions.Opt_F_Naturschutz);
    this.sysooptGroup.controls.Opt_O_UseRailProfil.setValue(this.cursysobjektoptions.Opt_O_UseRailProfil);
    this.sysooptGroup.controls.Opt_O_UseDIN1076.setValue(this.cursysobjektoptions.Opt_O_UseDIN1076);
    this.sysooptGroup.controls.Opt_O_UseMessReg.setValue(this.cursysobjektoptions.Opt_O_UseMessReg);
    this.sysooptGroup.controls.Opt_F_Drawing.setValue(this.cursysobjektoptions.Opt_F_Drawing);
    this.sysooptGroup.controls.Opt_O_UseKomponenten.setValue(this.cursysobjektoptions.Opt_O_UseKomponenten);
    this.sysooptGroup.controls.Opt_I_Zaehler.setValue(this.cursysobjektoptions.Opt_I_Zaehler);
    this.sysooptGroup.controls.Opt_I_Del_Old_Image.setValue(this.cursysobjektoptions.Opt_I_Del_Old_Image);
    this.sysooptGroup.controls.Opt_I_Fehlerklasse.setValue(this.cursysobjektoptions.Opt_I_Fehlerklasse);
    this.sysooptGroup.controls.Opt_I_Zustaend_Abt.setValue(this.cursysobjektoptions.Opt_I_Zustaend_Abt);
    this.sysooptGroup.controls.Opt_I_Gundinst.setValue(this.cursysobjektoptions.Opt_I_Gundinst);
    this.sysooptGroup.controls.Opt_I_PassBild.setValue(this.cursysobjektoptions.Opt_I_PassBild);
    this.sysooptGroup.controls.Opt_I_Track_BauwZustand.setValue(this.cursysobjektoptions.Opt_I_Track_BauwZustand);
    this.sysooptGroup.controls.Opt_I_Track_Spez_SchwellenNote.setValue(
      this.cursysobjektoptions.Opt_I_Track_Spez_SchwellenNote
    );
    this.sysooptGroup.controls.Opt_I_Track_Spez_Schwellenjahr.setValue(
      this.cursysobjektoptions.Opt_I_Track_Spez_Schwellenjahr
    );
    this.sysooptGroup.controls.Opt_I_Track_Spez_Schienenhoehe.setValue(
      this.cursysobjektoptions.Opt_I_Track_Spez_Schienenhoehe
    );
    this.sysooptGroup.controls.Opt_I_Track_Spez_Option_ZusatzI.setValue(
      this.cursysobjektoptions.Opt_I_Track_Spez_Option_ZusatzI
    );
    this.sysooptGroup.controls.Opt_I_Track_Spez_Option_ZusatzII.setValue(
      this.cursysobjektoptions.Opt_I_Track_Spez_Option_ZusatzII
    );
    this.sysooptGroup.controls.Opt_I_Track_Spez_Option_Unterbau.setValue(
      this.cursysobjektoptions.Opt_I_Track_Spez_Option_Unterbau
    );
    this.sysooptGroup.controls.Opt_I_Track_Spez_Option_Einbaujahr.setValue(
      this.cursysobjektoptions.Opt_I_Track_Spez_Option_Einbaujahr
    );
    this.sysooptGroup.controls.Opt_I_Track_Spez_Option_Daemmung.setValue(
      this.cursysobjektoptions.Opt_I_Track_Spez_Option_Daemmung
    );
    this.sysooptGroup.controls.Opt_I_Anlagenklasse.setValue(this.cursysobjektoptions.Opt_I_Anlagenklasse);
    this.sysooptGroup.controls.Opt_I_Track_Spez_Schienenjahr.setValue(
      this.cursysobjektoptions.Opt_I_Track_Spez_Schienenjahr
    );
    this.sysooptGroup.controls.Opt_I_PruefIntIsMessInt.setValue(this.cursysobjektoptions.Opt_I_PruefIntIsMessInt);
    this.sysooptGroup.controls.Opt_I_CheckList.setValue(this.cursysobjektoptions.Opt_I_CheckList);
    this.sysooptGroup.controls.Opt_E_OrdZustand.setValue(this.cursysobjektoptions.Opt_E_OrdZustand);
    this.sysooptGroup.controls.Opt_E_OrdZustand_TXT_IO.setValue(this.cursysobjektoptions.Opt_E_OrdZustand_TXT_IO);
    this.sysooptGroup.controls.Opt_E_OrdZustand_TXT_NIO.setValue(this.cursysobjektoptions.Opt_E_OrdZustand_TXT_NIO);
    this.sysooptGroup.controls.Opt_E_FK_ImageToDok.setValue(this.cursysobjektoptions.Opt_E_FK_ImageToDok);
    this.sysooptGroup.controls.Opt_E_Sperr_ImageToDok.setValue(this.cursysobjektoptions.Opt_E_Sperr_ImageToDok);
    this.sysooptGroup.controls.Opt_E_Spez_ListToDok.setValue(this.cursysobjektoptions.Opt_E_Spez_ListToDok);
    this.sysooptGroup.controls.Opt_E_Track_Spez_Schienenhoehe.setValue(
      this.cursysobjektoptions.Opt_E_Track_Spez_Schienenhoehe
    );
    this.sysooptGroup.controls.Opt_E_Fehlerklasse.setValue(this.cursysobjektoptions.Opt_E_Fehlerklasse);
    this.sysooptGroup.controls.Opt_E_Bezirk.setValue(this.cursysobjektoptions.Opt_E_Bezirk);
    this.sysooptGroup.controls.Opt_E_Stellwerk.setValue(this.cursysobjektoptions.Opt_E_Stellwerk);
    this.sysooptGroup.controls.Opt_E_MessReg.setValue(this.cursysobjektoptions.Opt_E_MessReg);
    this.sysooptGroup.controls.Opt_E_Track_Spez_Schwellenjahr.setValue(
      this.cursysobjektoptions.Opt_E_Track_Spez_Schwellenjahr
    );
    this.sysooptGroup.controls.Opt_K_Kalender.setValue(parseFloat(this.cursysobjektoptions.Opt_K_Kalender));
    this.sysooptGroup.controls.Opt_F_ZaehlerMessreg.setValue(this.cursysobjektoptions.Opt_F_ZaehlerMessreg);

    this.lastsysooptGroup = this.sysooptGroup.value;
    this.Opt_F_Zaehler = this.cursysobjektoptions.Opt_F_Zaehler;

    if (this.cursysobjektoptions.Opt_O_UseKomponenten == 1) {
      setTimeout(() => {
        this.loadKomponenten();
      }, 200);
    } else {
      this.UseKomponenten = false;
    }
  }

  public close() {
    this.closedialog.next(true);
  }

  async ngOnInit() {
    this.seltyp = 1;
    await Promise.all([
      this.loadSOTYP(),
      this.loadObjektPruefungTypen(),
      this.loadSysObjectOptions(),
      this.loadInterFaceOptions(),
    ]);
    this.selobjekt = this.objekte.rows[0];
    this.selectionObjektChanged(this.objekte.rows[0]);
    this.rights = JSON.parse(this.authService.decrypt(localStorage.getItem('rights')));
  }

  private async loadSOTYP() {
    const objekte = await firstValueFrom(this.apiservice.getSOTYPAll());
    if (this.objekte == undefined) {
      this.objekte = objekte;
    } else {
      this.objekte.rows = objekte.rows;
    }
  }

  private async loadObjektPruefungTypen() {
    const prufungen = await firstValueFrom(this.apiservice.getObjektPruefungTypen());
    this.pruefungen = prufungen;
    this.pruefungenOriginal = structuredClone(prufungen.rows);
  }

  private async loadSysObjectOptions() {
    const anlagen = await firstValueFrom(this.apiservice.getSysObjectOptions());
    this.sysobjektoptions = anlagen;
    this.sysobjektoptionsOriginal = structuredClone(anlagen.rows);
  }

  private async loadInterFaceOptions() {
    const res = await firstValueFrom(this.apiservice.getSettingsInterface({ status: 'get' }));
    if (res['ini']) {
      let ini = res['ini'].rows[0];
      this.optExportFormat = ini.optExportFormat;
      this.optSAPFieldEquipment = ini.optSAPFieldEquipment;
    }
  }

  onOpt_F_ZaehlerChange(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    this.Opt_F_Zaehler = checked ? 1 : 0;
    if (this.Opt_F_Zaehler == 0) {
      this.sysooptGroup.controls.Opt_F_ZaehlerMessreg.setValue(0);
    }
  }

  saveSysObjectOptions() {
    let vals = this.sysooptGroup.value;

    let sysoopt = {
      Opt_F_Einbauhistory: vals.Opt_F_Einbauhistory,
      Opt_F_Zaehler: vals.Opt_F_Zaehler,
      Opt_F_Linienbelegung: vals.Opt_F_Linienbelegung,
      Opt_F_Logbuch: vals.Opt_F_Logbuch,
      Opt_F_Bahnsteig: vals.Opt_F_Bahnsteig,
      Opt_F_BUESicht: vals.Opt_F_BUESicht,
      Opt_F_Trassierung: vals.Opt_F_Trassierung,
      Opt_F_GMTZNumber: vals.Opt_F_GMTZNumber,
      Opt_O_UseRailProfil: vals.Opt_O_UseRailProfil,
      Opt_O_UseDIN1076: vals.Opt_O_UseDIN1076,
      Opt_O_UseMessReg: vals.Opt_O_UseMessReg,
      Opt_F_Drawing: vals.Opt_F_Drawing,
      Opt_O_UseKomponenten: vals.Opt_O_UseKomponenten,
      Opt_I_Zaehler: vals.Opt_I_Zaehler,
      Opt_I_Del_Old_Image: vals.Opt_I_Del_Old_Image,
      Opt_I_Fehlerklasse: vals.Opt_I_Fehlerklasse,
      Opt_I_Zustaend_Abt: vals.Opt_I_Zustaend_Abt,
      Opt_I_Gundinst: vals.Opt_I_Gundinst,
      Opt_I_PassBild: vals.Opt_I_PassBild,
      Opt_I_Track_BauwZustand: vals.Opt_I_Track_BauwZustand,
      Opt_I_Track_Spez_SchwellenNote: vals.Opt_I_Track_Spez_SchwellenNote,
      Opt_I_Track_Spez_Schwellenjahr: vals.Opt_I_Track_Spez_Schwellenjahr,
      Opt_I_Track_Spez_Schienenhoehe: vals.Opt_I_Track_Spez_Schienenhoehe,
      Opt_I_Track_Spez_Option_ZusatzI: vals.Opt_I_Track_Spez_Option_ZusatzI,
      Opt_I_Track_Spez_Option_ZusatzII: vals.Opt_I_Track_Spez_Option_ZusatzII,
      Opt_I_Track_Spez_Option_Unterbau: vals.Opt_I_Track_Spez_Option_Unterbau,
      Opt_I_Track_Spez_Option_Einbaujahr: vals.Opt_I_Track_Spez_Option_Einbaujahr,
      Opt_I_Track_Spez_Option_Daemmung: vals.Opt_I_Track_Spez_Option_Daemmung,
      Opt_E_OrdZustand: vals.Opt_E_OrdZustand,
      Opt_E_OrdZustand_TXT_IO: vals.Opt_E_OrdZustand_TXT_IO,
      Opt_E_OrdZustand_TXT_NIO: vals.Opt_E_OrdZustand_TXT_NIO,
      Opt_E_FK_ImageToDok: vals.Opt_E_FK_ImageToDok,
      Opt_E_Sperr_ImageToDok: vals.Opt_E_Sperr_ImageToDok,
      Opt_E_Spez_ListToDok: vals.Opt_E_Spez_ListToDok,
      Opt_I_Anlagenklasse: vals.Opt_I_Anlagenklasse,
      Opt_I_Track_Spez_Schienenjahr: vals.Opt_I_Track_Spez_Schienenjahr,
      Opt_E_Track_Spez_Schienenhoehe: vals.Opt_E_Track_Spez_Schienenhoehe,
      Opt_E_Fehlerklasse: vals.Opt_E_Fehlerklasse,
      Opt_E_Bezirk: vals.Opt_E_Bezirk,
      Opt_E_Stellwerk: vals.Opt_E_Stellwerk,
      Opt_E_MessReg: vals.Opt_E_MessReg,
      Opt_E_Track_Spez_Schwellenjahr: vals.Opt_E_Track_Spez_Schwellenjahr,
      Opt_F_Stellkraftmessung: vals.Opt_F_Stellkraftmessung,
      Opt_F_Naturschutz: vals.Opt_F_Naturschutz,
      Opt_I_PruefIntIsMessInt: vals.Opt_I_PruefIntIsMessInt,
      Opt_I_CheckList: vals.Opt_I_CheckList,
      Opt_K_Kalender: vals.Opt_K_Kalender,
      Opt_F_ZaehlerMessreg: vals.Opt_F_ZaehlerMessreg,
      otypid: this.otypid,
      kprtypid: this.kprtypid,
    };

    this.apiservice
      .sendSysObjectOptions({ sysoopt })
      .pipe(first())
      .subscribe((val: any) => {
        if (val.anlagen) {
          this.sysobjektoptions = val.anlagen;
          this.sysobjektoptionsOriginal = structuredClone(val.anlagen.rows);
          this.toastr.success(this.mrTranslate.transform('Daten gespeichert'));
        } else {
          this.toastr.error(val.error);
        }
      });
  }

  showMangelbaum() {
    this.overlayService.setOverlay({
      overlay: 'mangelbaum',
      isTopOverlay: true,
      otypid: this.otypid,
    });
  }

  showChecklisten() {
    this.overlayService.setOverlay({
      overlay: 'checklistenMenu',
      isTopOverlay: true,
      id: {
        otypid: this.otypid,
      },
      zIndex: 10,
    });
  }

  showSpezifikationTemplate() {
    this.overlayService.setOverlay({
      overlay: 'gleisCodeVerwaltung',
      isTopOverlay: true,
    });
  }

  async startExport() {
    try {
      const res = await firstValueFrom(this.apiservice.getExportSOTYP(this.otypid));
      const blob = new Blob([res], { type: 'application/json' });
      const anchor = document.createElement('a');
      anchor.download = this.selobjekt.bezeichnung + '.json';
      anchor.href = (window.webkitURL || window.URL).createObjectURL(blob);
      anchor.click();
    } catch (er) {
      console.log(er);
      this.toastr.warning(this.mrTranslate.transform('Kein Export erstellt, Fehler im Log.'));
    }
  }

  startImport() {
    this.importObjektModal = true;
    this.webSocket._config.name = 'Objektart Importieren Progress';
    this.webSocket.startCon();
    this.webSocket.registerHandler('taskProgressChanged', ([info, percent]) => {
      this.importProgessValue = percent;
      this.info = info;
    });
    this.webSocket.registerHandler('taskErrored', info => {
      this.importProgessValue = '0';
      this.info = info;
      this.doUpload = false;
    });

    this.webSocket.registerHandler('taskEnded', () => {
      this.importObjektFile = undefined;
      this.importjsonObj = undefined;
      this.fileUploader.nativeElement.value = null;
      this.importProgessValue = '';
      this.doUpload = false;

      setTimeout(() => this.exitImport(), 1500);
    });
  }

  onFileSelect(mode, file) {
    if (file) {
      console.log(file);
      if (file.type == 'application/json') {
        this.importObjektFile = file;

        const fileReader = new FileReader();
        fileReader.readAsText(this.importObjektFile, 'UTF-8');
        fileReader.onload = () => {
          try {
            this.importjsonObj = JSON.parse(fileReader.result.toString());
          } catch (e) {
            this.toastr.error(e.toString());
          }

          this.fileUploader.nativeElement.value = null;
        };
        fileReader.onerror = error => {
          console.log(error);
          this.toastr.error(error.toString());
        };
      } else {
        this.toastr.warning('Please only upload json files');
      }
    }
  }

  exitImport() {
    this.importObjektModal = false;
    this.importObjektFile = undefined;
    this.importjsonObj = undefined;
    this.fileUploader.nativeElement.value = null;
    this.webSocket.stopCon();
  }

  async sendDBFile() {
    try {
      if (typeof this.importjsonObj != 'object') throw new Error('Falsches Format');

      this.importProgessValue = '';
      this.doUpload = true;

      const send: ImportObjektTypTable[] = [];
      for (const [name, table] of Object.entries(this.importjsonObj)) {
        if (
          typeof table != 'object' ||
          !('columns' in table) ||
          !Array.isArray(table.columns) ||
          !('rows' in table) ||
          !Array.isArray(table.rows)
        )
          throw new Error('Falsches Format');

        const columns = table.columns as Column[];
        const rows = table.rows as Row[];

        send.push({ name, columns, rows });
      }

      const { success, error } = await firstValueFrom(this.apiservice.importSOTYP(this.webSocket._id(), send));

      if (success) {
        this.loadSOTYP();
        this.loadObjektPruefungTypen();
        this.loadSysObjectOptions();
        this.toastr.success(this.mrTranslate.transform('Daten gespeichert'));
      } else this.toastr.warning(error, this.mrTranslate.transform('Ein Fehler ist aufgetreten'));
    } catch (er) {
      this.importProgessValue = '';
      this.doUpload = false;
      console.log(er);
      this.toastr.warning((er as Error).message, this.mrTranslate.transform('Ein Fehler ist aufgetreten'));
    }
  }
}

export interface ImportObjektTypTable extends Table {
  name: string;
}
